export default __webpack_public_path__ + "static/char-43-692469e18d14f93210f45fdcce79e421.webp";